export const getObjective = (addonItem, templateObjectives) => {
  const objective = addonItem.section
  const keyExists = templateObjectives.some((s) => s.tag !== 'phase' && s.tag === objective)
  if (!keyExists) {
    if (templateObjectives.some((s) => s.tag === 'objective:addons')) {
      return 'objective:addons'
    } else {
      return 'unknown'
    }
  }
  return objective
}
